/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureOnboardedTenantsResponse {
  /**
  * List of Azure tenant IDs where management apps are registered
  */
  'tenantIds': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantIds",
      "baseName": "tenantIds",
      "type": "Array<string>",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return AzureOnboardedTenantsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

